export class DateUtils {
    static addDays(days: number, date = new Date()) {
        date.setDate(date.getDate() + days);
        return date;
    }
    static parseDate(value: string): Date | null {
        if (value.includes('T')) {
            return new Date(value);
        }

        if (!value) return null;

        const parts = value.split('/');

        if (parts.length !== 3) return null;

        const day = Number(parts[0]);
        const month = Number(parts[1]) - 1;
        const year = Number(parts[2]);

        const date = new Date(year, month, day);

        if (isNaN(date.getTime())) return null;

        return date;
    }
}
